import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 300,
    borderBottom: `1px solid ${theme.grey7}`,
    paddingBottom: 15
  },
  body: {
    padding: '15px 0',
    width: '50%'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  label: {
    marginLeft: 15,
    width: 320
  },
  spacer: {
    flex: 1
  }
}));
